export default function XIcon({ ...rest }) {
  return (
    <svg
      width='10'
      height='10'
      viewBox='0 0 10 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path d='M1 1L9 9' stroke='#A9A9A9' strokeWidth='2' />
      <path d='M8.99988 1L0.999878 9' stroke='#A9A9A9' strokeWidth='2' />
    </svg>
  );
}
